export const EIGHT_NUMBER = 8;
export const TREE_NUMBER = 3;

export const TRIPLETS_KEY = "triplets";
export const EIGHTS_KEY = "eights";
export const OTHERS_KEY = "others";
